export interface IEnterpriseInfo {
    enterprise_id: string;
    enterprise_name: string;
    real_name: string;
    show_name: string;
    logo: string;
    logo_mobile: string;
    config: {
        enroll_auto_register_enterprise: number;
        enterprise_id: string;
        enterprise_name: string;
        hide_enroll_app_guide: number;
        hide_footer: number;
        hide_head_title: number;
        up: string;
    };
    role_type?: string;
    version_type?: number;
}
export interface IStudentInfo {
    weike_home_url: string;
    group_home_url: string;
    enterprise_home_url: string;
}
export interface IUserMedal {
    id: string;
    medal_rank: string;
    medal_type: string;
}
export interface IUserBaseInfo {
    user_level: number;
    user_growth_points: number;
    show_user_level: number;
    user_medal: IUserMedal;
    user_name: string;
    avatar: string;
    student_id: string;
    uid: string;
    umu_id:  number;
    home_url?: string;
    user_id?: string;
    person_home_url?: string;
}
export interface IUserInfo extends IUserBaseInfo {
    achievement_url: string;
    email: string;
    enterprise_info: IEnterpriseInfo;
    person_home_url: string;
    phone: string;
    phone_number: string;
    remark: string;
    student_id: string;
    student_info: IStudentInfo;
    teacher_id: string;
    teacher_info: {
        need_bind_mobile: number;
        register_from: number;
        register_step: number;
        teacher_status: number;
    }
}
export type ICallback = ([...args]: any) => void;

export default () => {
    return (window as any).pageData?.userInfo as IUserInfo
};
